import { render } from "./AdminButtons.vue?vue&type=template&id=3b46cda2"
import script from "./AdminButtons.vue?vue&type=script&lang=js"
export * from "./AdminButtons.vue?vue&type=script&lang=js"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__